import { MetadataModules } from '../../enums/index.js';
import { addTypedProvider, metadataModuleProvider } from '../../metaData.js';
export function dataLookup(dataType) {
    return (next, query, data, options) => {
        data ||= metadataModuleProvider(dataType, query, options?.[dataType]);
        return next(query, data, options);
    };
}
export const instanceLookup = dataLookup(MetadataModules.INSTANCE);
export const naturalLookup = dataLookup(MetadataModules.NATURALIZED);
export const DATA_PRIORITY = { priority: 5000 };
export function registerDataLookup() {
    addTypedProvider(MetadataModules.INSTANCE, dataLookup(MetadataModules.NATURALIZED), DATA_PRIORITY);
    addTypedProvider(MetadataModules.IMAGE_PLANE, instanceLookup, DATA_PRIORITY);
    addTypedProvider(MetadataModules.CALIBRATION, instanceLookup, DATA_PRIORITY);
    addTypedProvider(MetadataModules.COMPRESSED_FRAME_DATA, naturalLookup, DATA_PRIORITY);
    addTypedProvider(MetadataModules.SCALING, naturalLookup, DATA_PRIORITY);
}
